<template>
  <div>
    <VersionNoice></VersionNoice>
    <div id="home" class="container-home">
      <div class="container_bg">
        <div class="container_search">
          <div class="search_ipt">
            <n-auto-complete
              v-model:value="autoValue"
              class="complete_ipt"
              size="large"
              :loading="autoloading"
              :input-props="{
                autocomplete: 'disabled',
              }"
              clearable
              :options="autoOptions"
              placeholder="Retail Supper ..."
              @update:value="handleAutoComplete"
              @keyup.enter="searchHanlder"
            >
              <template #prefix>
                <svg-icon svg-icon class="contact_icon" icon-name="search_icon" icon-class="search_icon" />
              </template>
            </n-auto-complete>
          </div>
          <div>
            <n-button
              size="large"
              strong
              class="search_btn"
              :theme-overrides="themeButtonOverrides"
              color="#572DF3"
              @click="searchHanlder"
              >Search
            </n-button>
          </div>
        </div>
        <div class="container_tags">
          <div class="container_carousel">
            <swiper
              class="swiper-no-swiping"
              :navigation="true"
              :modules="[Navigation]"
              :slide-to-clicked-slide="false"
              :touch-start-prevent-default="false"
              :centered-slides="true"
              :space-between="0"
              :initial-slide="initialSlide"
              :slides-per-view="5"
              @swiper="onSwiper"
              @slide-change="onSlideChange"
            >
              <swiper-slide v-for="(item, index) in renderDataList" :key="index">
                <div v-if="index !== activeIndex" ref="charts" class="chart" @click="renderItemClickHandler(index)">
                  <v-chart
                    autoresize
                    :animation="false"
                    :layout-animation="false"
                    :update-options="{ notMerge: true, animation: false }"
                    :option="chartOption(item, index)"
                  />
                </div>
                <div v-else ref="charts" class="charts_container">
                  <v-chart
                    :animation="false"
                    :layout-animation="false"
                    :update-options="{ notMerge: true, animation: false }"
                    autoresize
                    :option="option2"
                    @click="onClick"
                  />
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div class="navi_container">
          <div class="container_navigation" :class="{ sm_client_buttom: bottomDistance }">
            <div
              v-for="(item, index) in renderDataList"
              :key="index"
              class="navigation_item"
              :class="{ navigation_item_active: activeIndex == index }"
              @click="renderItemClickHandler(index)"
            >
              {{ item.displayName }}
            </div>
          </div>
        </div>
      </div>
      <dataResort class="dataResort"></dataResort>

      <DataAssetValueSummary class="summary" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, computed, nextTick, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import debounce from 'lodash/debounce';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import dataResort from '@/views/pages/dataResource/dataResort/index.vue';
import DataAssetValueSummary from '@/views/pages/home/DataAssetValueSummary/index.vue';
import VersionNoice from '@/components/VersionNoice/index.vue';
import { getHomePage, getHomePageDetail } from '@/api/datawheel';
import { getDataSetList } from '@/api/dataset';
// import { load } from '@/utils/loading.js';

import { secondCircleList } from '../data/maincolor';

const router = useRouter();

const autoValue = ref('');

const autoloading = ref(false);
const autoOptions = ref([]);
const mainSwiperOption = ref({});
const clientHeight = document.documentElement.clientHeight;
const bottomDistance = ref(clientHeight < 730 ? true : false);

const fetchGetDataSetList = () => {
  autoloading.value = true;
  getDataSetList({
    layer: [],
    businessObject: [],
    status: [],
    piiFilter: '',
    lazyText: autoValue.value,
    dataWheelId: null,
    pageNo: 1,
    pageSize: 10,
    path: '/withoutAuth',
  }).then((res) => {
    const records = res.records.map((item: any) => ({
      label: item.name,
      value: item.name,
    }));
    autoloading.value = false;
    autoOptions.value = records;
  });
};
const handleAutoComplete = debounce(fetchGetDataSetList, 500);

const renderDataList: any = ref([]);
const option2 = ref({});
const charts = ref(null);
const activeIndex = ref(0);
const initialSlide = ref(parseInt(localStorage.getItem('initialSlide') || '7', 10));
const themeButtonOverrides = {
  borderRadiusLarge: '0 3px 3px 0',
};

const newSwiper = ref({
  slideTo: () => {
    return;
  },
});
const onSwiper = (value: any) => {
  newSwiper.value = value;
};

const searchHanlder = () => {
  router.push({
    name: '/dataasset',
    query: {
      lazyText: autoValue.value,
    },
  });
  // router.push({
  //   name: '/searchPage',
  //   query: {
  //     searchValue: autoValue.value,
  //     type: 'global',
  //   },
  // });
};

const chartOption = computed(() => {
  return (data: any, index: number) => {
    const calcSize = parseInt(getComputedStyle(window.document.documentElement)['font-size'], 10);
    const intervalNum = Math.abs(index - activeIndex.value);
    const mainSize = intervalNum > 1 ? 16 : 20;

    const series = [
      {
        type: 'pie',
        radius: ['0', '53%'],
        center: ['50%', '50%'],
        color: ['#FF18B4'],
        data: [
          {
            value: '1',
            name: data.displayName.replace(/\s+/g, '\n'),
            pathName: 'Customer',
            wheelId: data.parentWheelId,
          },
        ],
        label: {
          normal: {
            position: 'center',
            shadowBlur: 200,
            color: '#fff',
            textStyle: {
              fontSize: (mainSize / 192) * calcSize,
              fontFamily: 'BMWTypeNextRegular',
            },
          },
        },
      },
      {
        type: 'sunburst',
        nodeClick: false,
        itemStyle: {
          borderRadius: 1,
        },
        levels: [
          {},
          {
            r0: '55%',
            r: '90%',
            itemStyle: {
              opacity: 1,
            },
            label: {
              textStyle: {
                color: '#C7C7C7',
                fontWeight: 'bold',
                fontSize: (14 / 195) * 12,
              },
            },
          },
        ],
        data: (data.sonDisplayNames || []).map((item: any, indexItem: number) => {
          var shousizeNum = data.sonDisplayNames.length >= 8 ? 5 : 7;
          return {
            name: item.slice(0, intervalNum > 1 ? 5 : shousizeNum) + '...',
            wheelName: item,
            value: 1,
            label: {
              rotate: 'tangential',
              textStyle: {
                fontSize: intervalNum > 1 ? 8 : 12,
                fontFamily: 'BMWTypeNextRegular',
              },
            },
            itemStyle: {
              color: secondCircleList[indexItem % 4],
            },
          };
        }),
      },
      {
        name: '外层背景',
        type: 'pie',
        color: '#e9e0f6',
        radius: ['90%', '95%'],
        silent: true,
        label: {
          normal: {
            show: false,
          },
        },
        data: [
          {
            value: 0,
            name: '外层背景',
          },
        ],
      },
      {
        name: '111',
        type: 'pie',
        color: '#fbf8fd',
        radius: ['95%', '98%'],
        silent: true,
        label: {
          normal: {
            show: false,
          },
        },
        data: [
          {
            value: 0,
            name: '11111',
          },
        ],
      },
    ];

    return {
      animationEasing: 'cubicOut',
      backgroundColor: 'transparent',
      title: {
        x: 'center',
        y: 'center',
        textStyle: {
          fontSize: (24 / 192) * calcSize,
          color: '#FFFFFF',
        },
      },
      tooltip: {
        trigger: 'item',
        confine: true,
        appendToBody: true,
        formatter: (args: any) => {
          return args.data.wheelName;
        },
        textStyle: {
          fontFamily: 'BMWTypeNextRegular',
        },
      },
      series,
    };
  };
});

const fetchgetHomePage = () => {
  getHomePage().then((res) => {
    renderDataList.value = res;
    updateSwiperDom();
    const initParmasId = res[activeIndex.value]?.id || '';
    fetchgetHomePageDetail(initParmasId);
  });
};

const fetchgetHomePageDetail = (parentId: number) => {
  getHomePageDetail({
    parentId,
  }).then((res) => {
    mainSwiperOption.value = res;
    setChartsOptions(res);
  });
};

const setChartsOptions = (data: any) => {
  const calcSize = parseInt(getComputedStyle(window.document.documentElement)['font-size'], 10);

  const hasSon = data.son?.length;
  const maximumDepth = data.maximumDepth;

  const level3Array = [
    {},
    {
      r0: '28%',
      r: '58%',
      itemStyle: {
        opacity: 1,
      },
      label: {
        textStyle: {
          color: '#C7C7C7',
          fontWeight: 'bold',
          fontSize: (14 / 195) * calcSize,
        },
      },
    },
    {
      r0: '59%',
      r: '96%',
      label: {},
      itemStyle: {
        borderWidth: 1,
        borderColor: '#fff',
        opacity: 0.7,
        fontSize: 14,
      },
    },
  ];
  const level2Array = [
    {},
    {
      r0: '48%',
      r: '96%',
      itemStyle: {
        opacity: 1,
      },
      label: {
        textStyle: {
          color: '#C7C7C7',
          fontWeight: 'bold',
          fontSize: (14 / 195) * calcSize,
        },
      },
    },
  ];
  // 目前只考虑到三层还没到第四层
  // 至少有两级  2 / 3
  const series = [
    {
      type: 'pie',
      radius: ['0', maximumDepth === 2 ? '46.6%' : '26.6%'],
      center: ['50%', '50%'],
      color: ['#FFA201'],
      data: [
        {
          value: 100,
          name: data.displayName.replace(/\s+/g, '\n'),
          wheelName: data.displayName,
          pathName: 'Customer',
          wheelId: data.id,
          linkDBO: data.linkDBO,
          target: 'blank',
        },
      ],
      label: {
        normal: {
          position: 'center',
          shadowBlur: 200,
          color: '#fff',
          textShadowColor: '#666',
          textBorderColor: '#666',
          textStyle: {
            fontSize: (26 / 195) * calcSize,
            fontWeight: 'bold',
            textShadowColor: '#666',
            textBorderColor: '#666',
            fontFamily: 'BMWTypeNextRegular',
          },
        },
      },
    },
    {
      type: 'sunburst',
      nodeClick: false,
      levels: maximumDepth === 2 ? level2Array : level3Array,
      data: hasSon ? fommaterSeries(data.son, 0, data.lastedTagSum, '', data.linkDBO) : [],
    },
    {
      name: '外层背景',
      type: 'pie',
      color: '#EADEF6',
      radius: ['96%', '98%'],
      silent: true,
      label: {
        normal: {
          show: false,
        },
      },
      data: [
        {
          value: 0,
          name: '外层背景',
        },
      ],
    },
    {
      name: '111',
      type: 'pie',
      color: '#F1E6F9',
      radius: ['98%', '100%'],
      silent: true,
      label: {
        normal: {
          show: false,
        },
      },
      data: [
        {
          value: 0,
          name: '11111',
        },
      ],
    },
  ];

  const initChartsOptions = {
    animationEasing: 'cubicOut',
    backgroundColor: 'transparent',
    title: {
      x: 'center',
      y: 'center',
      textStyle: {
        fontSize: 24,
        color: '#FFFFFF',
      },
    },
    tooltip: {
      trigger: 'item',
      confine: true,
      formatter: (args: any) => {
        return args.data.wheelName;
      },
      textStyle: {
        fontSize: (18 / 192) * calcSize,
        fontFamily: 'BMWTypeNextRegular',
      },
    },
    series,
  };

  nextTick(() => {
    option2.value = initChartsOptions;
  });
};

const fommaterChildText = (text: string, lastedTagSum: number, proportion: number, level: number) => {
  let maxlength = 18;
  let propNum = lastedTagSum / proportion;

  if (level === 0) {
    let initText = text.replace(/\s+/g, '\n');
    let fommatText = initText
      .split('\n')
      .map((itext: string) => (itext.length > 10 ? itext.slice(0, 10) + '...' : itext))
      .join('\n');
    let arrText = fommatText.split('\n');
    if (propNum < 0.1) {
      arrText.length = 2;
    }
    let showText = arrText.join('\n');
    return showText;
  } else {
    let fommText = text.split(/\s+/).slice(0, 4).join('\n');
    let inittext = text.length < maxlength ? text : propNum <= 0.03 ? text.slice(0, 15) + '...' : fommText;
    return inittext;
  }
};

const fommaterSeries = (data: any, level: number, proportion: number, color: string, parentWheelName: any) => {
  const value: any[] = [];
  (data || []).forEach((item: any, index: number) => {
    const opacity = 1 - Number(`0.${level}`);
    const calcSize = parseInt(getComputedStyle(window.document.documentElement)['font-size'], 10);
    const fintSzie = level === 0 ? 14 : 12;
    // 防止第四层菜单
    if (level === 2) return;
    value.push({
      hoverAnimation: false,
      name: fommaterChildText(item.displayName, item.lastedTagSum, proportion, level),
      wheelName: item.displayName,
      wheelId: item.id,
      label: {
        rotate: 'radial',
        position: level === 0 ? '' : 'inside',
        textStyle: {
          color: '#C7C7C7',
          fontWeight: 'bold',
        },
        fontSize: (fintSzie / 192) * calcSize,
        fontFamily: 'BMWTypeNextRegular',
      },
      parentWheelName: parentWheelName,
      // 占比
      value: item.lastedTagSum / proportion,
      // value: 1,
      itemStyle: {
        color: color ? color : secondCircleList[index % 4],
        opacity: opacity,
      },
      children: fommaterSeries(item.son, level + 1, proportion, secondCircleList[index % 4], parentWheelName),
      tooltip: {
        // 下面两个参数必须同时有，否则不生效
        trigger: 'item',
        formatter: item.displayName,
        textStyle: {
          fontSize: (18 / 192) * calcSize,
          fontFamily: 'BMWTypeNextRegular',
        },
      },
    });
  });
  return value;
};

const onSlideChange = (slideObject: object | any) => {
  activeIndex.value = slideObject.activeIndex;
  window.localStorage.setItem('initialSlide', slideObject.activeIndex);

  if (!renderDataList.value.length) return;
  nextTick(() => {
    const initParmasId = renderDataList.value[slideObject.activeIndex].id;
    fetchgetHomePageDetail(initParmasId);
    updateSwiperDom();
  });
};
const onClick = (event: any) => {
  const { data = {} } = event;
  const { wheelId = '', target = '', parentWheelName = '', linkDBO = '' } = data;

  if (target === 'blank') {
    router.push({ name: '/dataasset', query: { dbo: linkDBO } });
    return;
  }
  router.push({ name: '/dataasset', query: { wheelId, dbo: parentWheelName } });
};

const renderItemClickHandler = (index: number) => {
  newSwiper.value.slideTo(index, 500);
  // localstroage
  window.localStorage.setItem('initialSlide', index);
};

const updateSwiperDom = () => {
  nextTick(() => {
    const previousDom = document.getElementsByClassName('swiper-slide-prev')[0];
    const nextDom = document.getElementsByClassName('swiper-slide-next')[0];
    if (previousDom || nextDom) {
      (charts.value || []).forEach((element: any) => {
        const chartWdith = element?.offsetWidth || 0;
        element.style.height = chartWdith + 'px';
      });
    }
  });
};

const reseizeCharts = () => {
  setChartsOptions(mainSwiperOption.value);
};

onMounted(() => {
  fetchgetHomePage();
  // load.show();

  window.addEventListener('resize', reseizeCharts);
});

onUnmounted(() => {
  window.removeEventListener('resize', reseizeCharts);
});
</script>

<style lang="scss" scoped>
.container-home {
  height: calc(100vh - 56px);
  overflow: scroll;
  scroll-snap-type: y mandatory;
}
.summary {
  background-image: url('../assets/edm_bg.png');
}
.dataResort,
.summary {
  height: calc(100vh - 56px);
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  scroll-snap-align: start;
}
.container_carousel {
  margin-top: 44px;
}

.chart {
  width: 100%;
  border-radius: 50%;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    line-height: 1;
  }
}

.swiper-slide {
  padding: 100px;
  box-sizing: border-box;
  // height: 1px;
}

.swiper-slide-prev {
  padding: 50px 100px 50px 0;
  transform: translateX(-70px);
}

.swiper-slide-next {
  padding: 50px 0 50px 100px;
  transform: translateX(70px);
}

.swiper-slide-active {
  padding: 0;
  z-index: 10;
}

.swiper-button-next {
  height: 55px;
  width: 30px;
  background-color: red;
}

.charts_container {
  z-index: 10;
  width: 600px;
  height: 600px;
  transform: translateX(-50%);
  margin-left: 50%;
}

.navi_container {
  display: flex;
  justify-content: center;
}

.container_navigation {
  display: flex;
  width: 80%;
  flex-flow: wrap;
  margin: 52px auto 0;
  justify-content: center;
  z-index: 100;
}

.sm_client_buttom {
  // bottom: 50px;
  margin-top: 25px;
}

.navigation_item {
  padding: 0 36px;
  cursor: pointer;
  color: #999999;
  font-size: 17px;
  position: relative;

  &::after {
    content: '';
    height: 16px;
    width: 1px;
    background-color: #ccc;
    position: absolute;
    right: 0;
    top: 6px;
  }

  &:last-child {
    &::after {
      content: '';
      background-color: transparent;
    }
  }
}

.navigation_item_active {
  color: #572df3;
  font-weight: bold;
}

.container_bg {
  width: 100%;
  min-height: calc(100vh - 56px);
  background-image: url('../assets/edm_bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  padding-top: 44px;
  padding-bottom: 10px;
  scroll-snap-align: start;
}

.container_search {
  width: 642px;
  // height: 54px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  // justify-content: space-between;
}

.search_ipt {
  width: 502px;
  height: 56px;
}

.search_btn {
  color: #fff;
  font-weight: bold;
}

.container_tags {
  width: 100%;
  overflow: hidden;
  position: relative;
  min-width: 600px;
}

.tagcloud {
  position: relative;
  margin-top: 200px;
}

.carousel-img {
  width: 100%;
  object-fit: cover;
}

.title123 {
  font-size: 8px;
}

.n-input__input {
  display: flex;
  align-items: center;
}

@media screen and (max-height: 730px) {
  .container_bg {
    padding-top: 18px;
  }

  .container_carousel {
    margin-top: 14px;
  }

  .container_navigation {
    margin-top: 10px;
  }
}
</style>

<style lang="scss">
.swiper-button-next,
.swiper-button-prev {
  width: 40px;
  height: 72px;
  background-color: #bdc7ea;
  border-radius: 4px;

  &::after {
    color: #fff;
  }
}

.swiper-wrapper {
  display: flex;
  align-items: center;
}
</style>
